import { ChangelogVersion } from './changelog-version';
import { StandardEntity } from '../../engine/standard-entity';

export class Changelog extends StandardEntity {
  public override id: string;
  public product: string;
  private _versions: ChangelogVersion[] = [];
  get versions(): ChangelogVersion[] {
    return this._versions;
  }

  private _versionsRead: string[] = [];
  get versionsRead() {
    return this._versionsRead;
  }

  public get hasVersion(): boolean {
    return this._versions.length > 0;
  }

  public get hasNewVersion(): boolean {
    return this._versions.filter((v) => v.isNew === true).length > 0;
  }

  constructor(
    id: string,
    product: string,
    versionsRead?: string[] | undefined,
  ) {
    super();
    this.id = id;
    this.product = product;
    this.initVersionsRead(versionsRead);
  }

  private initVersionsRead(versionsRead?: string[] | undefined) {
    if (!versionsRead) {
      return;
    }
    this._versionsRead = versionsRead;
  }
  addReadVersion(changelogVersion: ChangelogVersion) {
    const versionSet = new Set(this._versionsRead);
    versionSet.add(changelogVersion.id);
    this._versionsRead = Array.from(versionSet);
  }

  addVersion(changelogVersion: ChangelogVersion) {
    changelogVersion.isNew = !this._versionsRead.includes(changelogVersion.id);
    this._versions.push(changelogVersion);
  }

  public sortVersionsByDate(): void {
    this._versions = this._versions.sort((a, b) => {
      const aDate = isNaN(a.date.getDate()) ? 0 : a.date.getTime();
      const bDate = isNaN(b.date.getDate()) ? 0 : b.date.getTime();
      return bDate - aDate;
    });
  }
}
